// @flow

import "core-js/stable";  // needed for promises and async/await
import "regenerator-runtime/runtime"; // needed for promises and async/await
import { Core } from '../../../VanillaCore';

import FormComponent from '../../tags/form/form-component';
import PasswordPolicyComponent from "./password-policy-component";
import MultiStepProgressComponent from "./multi-step-progress-component";

class FormController extends Core.Controller {

    constructor() {
        super();

        // register the components
        this.registerComponent('form-component', FormComponent);
        this.registerComponent('password-policy-component', PasswordPolicyComponent);
        this.registerComponent('multi-step-progress-component', MultiStepProgressComponent);
    }

    model() {
    }
}

document.addEventListener('DOMContentLoaded', () => {
    window.formController = new FormController();
    formController.start();
});
